// SynergyFlow pages: entrances, the "type your shop's name" preview and the FlowDesk demo (orders on a tablet, bookings by email).
(function () {
  var root = document.querySelector('.sf');
  if (!root) return;
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // the first screen fills the window under the theme's header, whatever height that header is
  var header = document.querySelector('.section-header, .pv-header');
  if (header) document.documentElement.style.setProperty('--sf-header-h', header.offsetHeight + 'px');

  // ---------- entrances: the parts of a section arrive in reading order, once ----------
  var targets = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
  targets.forEach(function (el) {
    Array.prototype.forEach.call(el.children, function (child, i) { child.style.setProperty('--i', i); });
  });
  var io = null;
  var show = function (el) { el.classList.add('is-in'); if (io) io.unobserve(el); };
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) show(e.target); });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    targets.forEach(function (el) { io.observe(el); });
    // A fast scroll or a jump to an anchor can carry a section past the screen between two frames,
    // and the observer never sees it. Anything already above the bottom of the screen is shown.
    var queued = false;
    var sweep = function () {
      queued = false;
      targets = targets.filter(function (el) {
        if (el.classList.contains('is-in')) return false;
        if (el.getBoundingClientRect().top < innerHeight) { show(el); return false; }
        return true;
      });
      if (!targets.length) removeEventListener('scroll', onScroll);
    };
    var onScroll = function () { if (!queued) { queued = true; requestAnimationFrame(sweep); } };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('load', sweep);
  } else {
    targets.forEach(show);
  }

  // ---------- looping phone videos play only while on screen ----------
  document.querySelectorAll('.sf-video').forEach(function (video) {
    if (reduced || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) video.play().catch(function () {}); else video.pause(); });
    }, { threshold: 0.2 }).observe(video);
  });

  // ---------- type your shop's name: a small website answers as you type ----------
  var input = document.getElementById('sf-type-input');
  if (input) {
    var site = document.querySelector('.sf-site');
    var KINDS = [
      { test: /barber|hair|salon|cuts?\b/i, colour: '#1f3f8f', tint: '#eef3ff', head: 'Book your next cut', hours: 'Open today 9 AM to 6 PM', cta: 'Book a time',
        list: [['Haircut', '$30'], ['Beard trim', '$20'], ['Haircut and beard', '$45']] },
      { test: /nail|spa|lash|beauty|brow|massage/i, colour: '#8f2f6a', tint: '#fff0f7', head: 'Book a visit', hours: 'Open today 10 AM to 7 PM', cta: 'Book a time',
        list: [['Manicure', '$35'], ['Pedicure', '$45'], ['Gel nails', '$50']] },
      { test: /bake|bakery|bread|cafe|café|coffee|donut|cake/i, colour: '#7a4b2a', tint: '#fff6ec', head: 'Fresh every morning', hours: 'Open today 7 AM to 3 PM', cta: 'Order ahead',
        list: [['Coffee', '$3'], ['Cinnamon bun', '$4'], ['Sourdough loaf', '$8']] },
      { test: /plumb|electric|roof|clean|construct|repair|landscap|paint|heating|hvac|auto|garage/i, colour: '#14532d', tint: '#effaf2', head: 'Free quotes in Portage', hours: 'Open Monday to Saturday', cta: 'Get a quote',
        list: [['Repairs', 'Same week'], ['New installs', 'Free quote'], ['Emergencies', 'Call us']] },
    ];
    var FOOD = { colour: '#b3261e', tint: '#fff8ee', head: 'Order online or call', hours: 'Open today 11 AM to 9 PM', cta: 'Order now',
      list: [['Large pizza', '$22'], ['Wings, 1 lb', '$15'], ['Caesar salad', '$9']] };
    var paint = function () {
      var name = input.value.trim() || 'Your Shop';
      var kind = KINDS.filter(function (k) { return k.test.test(name); })[0] || FOOD;
      site.style.setProperty('--site', kind.colour);
      site.style.setProperty('--site-t', kind.tint);
      site.querySelector('[data-site-name]').textContent = name;
      site.querySelector('[data-site-head]').textContent = kind.head;
      site.querySelector('[data-site-hours]').textContent = kind.hours;
      site.querySelector('[data-site-cta]').textContent = kind.cta;
      var list = site.querySelector('[data-site-list]');
      list.textContent = '';
      kind.list.forEach(function (row) {
        var li = document.createElement('li');
        var a = document.createElement('span'); a.textContent = row[0];
        var b = document.createElement('b'); b.textContent = row[1];
        li.append(a, b); list.append(li);
      });
    };
    input.addEventListener('input', paint);
    input.addEventListener('focus', function () { if (input.value === 'Your Shop') input.select(); });
    document.querySelectorAll('[data-fill]').forEach(function (b) {
      b.addEventListener('click', function () { input.value = b.dataset.fill; paint(); });
    });
    paint();
  }

  // ---------- the FlowDesk demo: orders ring on a tablet, bookings arrive by email ----------
  var form = document.querySelector('.sf-controls');
  var tablet = document.querySelector('.sf-tablet');
  var inbox = document.querySelector('.sf-inbox');
  if (!form || !tablet || !inbox) return;
  var lists = { new: tablet.querySelector('[data-list="new"]'), accepted: tablet.querySelector('[data-list="accepted"]') };
  var counts = { new: tablet.querySelector('[data-count="new"]'), accepted: tablet.querySelector('[data-count="accepted"]') };
  var alarm = tablet.querySelector('[data-alarm]');
  var mailList = inbox.querySelector('[data-mail]');
  var mailOpen = inbox.querySelector('[data-mail-open]');
  var sendBtn = form.querySelector('[data-send]');
  var note = form.querySelector('[data-note]');
  var qtyOut = form.querySelector('output[name="qty"]');
  var SIZE = { s: 'Small 10"', m: 'Medium 12"', l: 'Large 15"' };
  var TAX = 12, DELIVERY = 3.5; // the 12% (GST + RST) and the delivery fee from benvenutopizza.ca's checkout
  var money = function (n) { return '$' + n.toFixed(2); };
  var timeFmt = new Intl.DateTimeFormat('en-CA', { hour: 'numeric', minute: '2-digit' });
  var state = { mode: 'order', phase: 'draft', qty: 1, code: 0, minutes: 0, reason: '', sentAt: 0 };
  var ring = null;
  var val = function (name) { var el = form.querySelector('input[name="' + name + '"]:checked'); return el ? el.value : ''; };

  function current() {
    var who = (form.who.value || '').trim() || 'Customer';
    var pay = val('pay');
    if (state.mode === 'book') {
      var opt = form.service.selectedOptions[0];
      return { who: who, pay: pay, service: opt.value, mins: opt.dataset.mins, when: val('day') + ' at ' + val('time'), total: parseFloat(opt.dataset.price) };
    }
    var p = form.pizza.selectedOptions[0];
    var each = parseFloat(p.dataset[val('size')]);
    var how = val('how');
    var subC = Math.round(each * 100) * state.qty;
    var feeC = how === 'Delivery' ? Math.round(DELIVERY * 100) : 0;
    var taxC = Math.round(((subC + feeC) * TAX) / 100);
    return { who: who, pay: pay, pizza: p.value, size: SIZE[val('size')], each: each, how: how,
      sub: subC / 100, fee: feeC / 100, tax: taxC / 100, total: (subC + feeC + taxC) / 100 };
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function button(cls, text, fn) { var b = el('button', cls, text); b.type = 'button'; b.addEventListener('click', fn); return b; }

  // An order is a card on the tablet, the same card the real Benvenuto tablet shows.
  function card(o) {
    var c = el('article', 'sf-card');
    var top = el('div', 'sf-card__top');
    top.append(el('span', 'sf-code', state.phase === 'draft' ? 'Not sent' : '#' + state.code));
    top.append(el('span', 'sf-chip' + (o.how === 'Delivery' ? ' sf-chip--delivery' : ''), o.how));
    top.append(el('span', 'sf-age', state.phase === 'draft' ? 'being made' : state.phase === 'accepted' ? 'Accepted ' + timeFmt.format(state.sentAt) : 'just now'));
    c.append(top, el('p', 'sf-card__name', o.who));
    c.append(el('p', '', o.how === 'Delivery' ? 'Deliver to: 123 Anywhere St' : 'Pick-up at the shop'));
    var items = el('ul', 'sf-items');
    var li = el('li');
    var n = el('span', '', o.pizza);
    n.append(el('small', '', o.size));
    li.append(el('b', '', state.qty + '×'), n, el('span', '', money(o.each * state.qty)));
    li.lastChild.style.flex = '0';
    items.append(li);
    c.append(items);
    c.append(el('p', 'sf-paybar' + (o.pay === 'Card' ? ' sf-paybar--card' : ''), 'Paying by ' + o.pay.toLowerCase()));
    var t = el('div', 'sf-totals');
    t.append(el('span', '', 'Subtotal'), el('span', '', money(o.sub)));
    if (o.fee) t.append(el('span', '', 'Delivery'), el('span', '', money(o.fee)));
    t.append(el('span', '', 'Tax (12%)'), el('span', '', money(o.tax)));
    t.append(el('span', 'is-total', 'Total'), el('span', 'is-total', money(o.total)));
    c.append(t);
    return c;
  }

  function renderTablet(o) {
    lists.new.textContent = ''; lists.accepted.textContent = '';
    var c = card(o);
    var where = 'new';
    if (state.phase === 'draft') {
      c.classList.add('sf-card--draft');
    } else if (state.phase === 'ringing') {
      c.classList.add('sf-card--new', 'sf-card--ringing');
      c.append(button('sf-accept', 'Accept', function () { stopRing(); state.phase = 'picking'; render(); }));
      c.append(button('sf-decline', 'Decline', function () { stopRing(); state.phase = 'declining'; render(); }));
    } else if (state.phase === 'picking') {
      c.classList.add('sf-card--new');
      var picker = el('div', 'sf-picker');
      picker.append(el('p', '', 'Ready in how long?'));
      var row = el('div');
      [15, 30, 45, 60].forEach(function (m) {
        var b = button('', String(m), function () { state.minutes = m; state.phase = 'accepted'; render(); });
        b.append(el('small', '', 'minutes'));
        row.append(b);
      });
      picker.append(row);
      c.append(picker);
    } else if (state.phase === 'declining') {
      c.classList.add('sf-card--new');
      var reasons = el('div', 'sf-reasons');
      reasons.append(el('p', '', 'Why are you declining?'));
      ['Too busy right now', 'Out of an ingredient', 'Closed for the night'].forEach(function (r) {
        reasons.append(button('', r, function () { state.reason = r; state.phase = 'declined'; render(); }));
      });
      c.append(reasons);
    } else if (state.phase === 'accepted') {
      c.classList.add('sf-card--accepted');
      var eta = el('p', 'sf-eta');
      eta.append(el('strong', '', 'Ready by ' + timeFmt.format(state.sentAt + state.minutes * 60000)), document.createTextNode(' (' + state.minutes + ' min estimate)'));
      c.append(eta);
      where = 'accepted';
    } else if (state.phase === 'declined') {
      c.classList.add('sf-card--declined');
      c.append(el('p', 'sf-declinedbar', 'Declined: ' + state.reason));
    }
    lists[where].append(c);
    var other = where === 'new' ? 'accepted' : 'new';
    lists[other].append(el('p', 'sf-empty', other === 'new' ? 'No new orders' : 'Nothing in progress'));
    counts.new.textContent = where === 'new' && state.phase !== 'draft' && state.phase !== 'declined' ? '1' : '0';
    counts.accepted.textContent = where === 'accepted' ? '1' : '0';
    alarm.hidden = state.phase !== 'ringing';
  }

  // A booking is an email in the shop's inbox. Nothing has to be accepted.
  function renderInbox(o) {
    mailList.querySelectorAll('.is-new').forEach(function (li) { li.remove(); });
    var when = o.when.charAt(0).toLowerCase() + o.when.slice(1);
    var subject = 'New booking: ' + o.service + ', ' + when;
    if (state.phase === 'sent') {
      var li = el('li', 'is-new');
      li.append(el('span', '', 'Your website'), el('span', '', subject), el('span', '', 'now'));
      mailList.prepend(li);
    }
    mailOpen.textContent = '';
    mailOpen.classList.toggle('is-draft', state.phase === 'draft');
    if (state.phase === 'draft') mailOpen.append(el('p', 'sf-mail__tag', 'Not sent yet'));
    mailOpen.append(el('p', 'sf-mail__subject', subject), el('p', 'sf-mail__from', 'From your website, to your email'));
    var dl = el('dl');
    [['Name', o.who], ['Phone', '204-555-0123'], ['Service', o.service + ', ' + o.mins + ' min'], ['When', o.when], ['Price', money(o.total) + ', paying by ' + o.pay.toLowerCase() + ' at the visit']]
      .forEach(function (r) { dl.append(el('dt', '', r[0]), el('dd', '', r[1])); });
    mailOpen.append(dl, el('span', 'sf-mail__reply', 'Reply to ' + o.who));
  }

  function render() {
    var book = state.mode === 'book';
    var o = current();
    form.querySelector('[data-total]').textContent = money(o.total);
    form.querySelector('[data-total-label]').textContent = book ? 'Price' : 'Total with tax';
    qtyOut.value = state.qty;
    if (book) renderInbox(o); else renderTablet(o);

    var sent = state.phase !== 'draft';
    sendBtn.disabled = sent;
    sendBtn.textContent = sent ? (book ? 'Booking sent' : 'Order sent') : (book ? 'Send booking' : 'Send order');
    form.setAttribute('aria-disabled', sent ? 'true' : 'false');
    note.textContent = '';
    var msg = '';
    // the time always ends in "a.m." or "p.m.", which closes the sentence
    if (book && state.phase === 'sent') msg = 'On the customer’s phone: Booking sent for ' + o.when.charAt(0).toLowerCase() + o.when.slice(1) + ' The shop gets it by email. ';
    if (!book) {
      if (state.phase === 'ringing') note.textContent = 'The tablet is ringing. Tap Accept or Decline on it.';
      if (state.phase === 'picking') note.textContent = 'Pick how long it will take.';
      if (state.phase === 'declining') note.textContent = 'Pick a reason. The customer sees it.';
      if (state.phase === 'accepted') msg = 'On the customer’s phone: Order #' + state.code + ' accepted, ready by ' + timeFmt.format(state.sentAt + state.minutes * 60000) + ' ';
      if (state.phase === 'declined') msg = 'On the customer’s phone: Order #' + state.code + ' declined: ' + state.reason.toLowerCase() + ' ';
    }
    if (msg) {
      note.append(document.createTextNode(msg));
      note.append(button('', 'Start over', function () { state.phase = 'draft'; render(); }));
    }
  }

  // Two short tones every 1.2 seconds, like the shop's alarm, for at most ten seconds.
  function startRing() {
    if (!form.sound.checked) return;
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    var ctx = new AC();
    var beep = function (at, freq) {
      var osc = ctx.createOscillator(), gain = ctx.createGain();
      osc.type = 'square'; osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, at);
      gain.gain.exponentialRampToValueAtTime(0.06, at + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, at + 0.18);
      osc.connect(gain).connect(ctx.destination);
      osc.start(at); osc.stop(at + 0.2);
    };
    var n = 0;
    var tick = function () {
      if (n++ > 8) return stopRing();
      beep(ctx.currentTime, 880); beep(ctx.currentTime + 0.24, 660);
    };
    tick();
    ring = { ctx: ctx, timer: setInterval(tick, 1200) };
  }
  function stopRing() {
    if (!ring) return;
    clearInterval(ring.timer);
    ring.ctx.close();
    ring = null;
  }

  function setMode(mode) {
    stopRing();
    state.mode = mode; state.phase = 'draft';
    document.querySelectorAll('[data-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.mode === mode ? 'true' : 'false'); });
    form.querySelector('[data-group="order"]').hidden = mode !== 'order';
    form.querySelector('[data-group="book"]').hidden = mode !== 'book';
    form.querySelectorAll('[data-only="order"]').forEach(function (n) { n.hidden = mode !== 'order'; });
    form.querySelector('[data-form-title]').textContent = mode === 'book' ? 'Your booking' : 'Your order';
    tablet.hidden = mode === 'book';
    inbox.hidden = mode !== 'book';
    render();
  }
  document.querySelectorAll('[data-mode]').forEach(function (b) { b.addEventListener('click', function () { setMode(b.dataset.mode); }); });

  form.addEventListener('input', render);
  form.addEventListener('change', render);
  form.querySelectorAll('[data-step]').forEach(function (b) {
    b.addEventListener('click', function () { state.qty = Math.min(9, Math.max(1, state.qty + Number(b.dataset.step))); render(); });
  });
  sendBtn.addEventListener('click', function () {
    var book = state.mode === 'book';
    state.phase = book ? 'sent' : 'ringing';
    state.code = 100 + Math.floor(Math.random() * 900);
    state.sentAt = Date.now();
    render();
    if (!book) startRing();
    // On a phone the tablet or inbox sits above the form, out of sight; bring it up.
    if (matchMedia('(max-width: 989px)').matches) (book ? inbox : tablet).scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  });
  render();
})();
